import styled from 'styled-components'

export const UnShrinkableBlock = styled.div`
  flex: 0 0 auto;
  width: auto;
`

UnShrinkableBlock.displayName = 'UnShrinkableBlock'
